import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TrustPilotComponent } from '../../trust-pilot/trust-pilot.component';

@Component({
  selector: 'app-common-subproducts-logos',
  templateUrl: './logos.component.html',
  styleUrls: ['./logos.component.scss'],
  imports: [CommonModule, TrustPilotComponent],
})
export class CommonSubProductsLogosComponent implements OnInit {
  @Input() logosData: any;
  @Input() customClass: any;
  constructor() {}
  _logosData: any;
  ngOnInit(): void {
    this._logosData = this.logosData;
  }
  ngOnChanges(): void {
    this._logosData = this.logosData;
  }
}
